
function Home() {
  return (
    <div className="flex flex-col justify-between min-h-screen bg-zinc-950 pb-8">
      <div className="flex-grow flex flex-col justify-center">
        <div className="text-zinc-700 max-w-72 leading-5 mx-auto animate-fadein">
          <p className="mb-3"><span className="text-zinc-200">SPENCER MATEEGA.</span></p>
          {/* <p className="mb-3">thinking about and building technology.</p> */}
          <p className="mb-3">co-founder and CEO, <a className="hover:text-zinc-500" href="https://afterquery.com" target="_blank">AfterQuery</a>.</p>
          <p className="mb-3">studied finance, statistics, and computer science at Wharton and Penn.</p>
        </div>
      </div>

      <div className="flex justify-center mb-2 animate-fadein">
        <p className="text-zinc-700">
          <a className="hover:text-zinc-500" href="https://twitter.com/spencermateega" target="_blank">x</a>
          <span className="mx-2">/</span>
          <a className="hover:text-zinc-500" href="https://www.linkedin.com/in/spencermateega/" target="_blank">linkedin</a>
        </p>
      </div>
    </div>
  );
}

export default Home;



